module.exports = __webpack_public_path__ + "static/img/dgf1.3a82fba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinqingBrand/assets/dgf1.jpg
// module id = ZHQv
// module chunks = 0